import React from "react";

function FinanceRedefined() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Finance Redefined with Crypto Banking Industry</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  The crypto banking industry represents a transformative shift
                  in the way financial services are accessed and managed. By
                  integrating blockchain technology with traditional banking
                  functions, crypto banking enables secure, transparent, and
                  efficient financial transactions, making financial freedom
                  more accessible globally. As cryptocurrencies gain acceptance,
                  the crypto banking industry is bridging the gap between
                  digital assets and mainstream financial services, redefining
                  how users interact with their money.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default FinanceRedefined;
